"use client";
import Link from "next/link";
import {useSession} from "next-auth/react";
import {Button} from "@/components/ui/button";
import AuthAction from "@/components/site/AuthAction";

export default function Header({isGrey=false}){
    const session = useSession();

    return(
        <header className={`padding-x padding-y ${isGrey ? 'bg-[#F5F6F8]' : ''}`}>
            <nav className={"flex justify-between items-center"}>
                <Link href={"/"}>
                    <img src={"/Logo.svg"} alt={"logo"} height={50} width={80}/>
                </Link>
                <AuthAction
                    trigger={(
                        <Button>
                            Connectez-vous
                        </Button>
                    )}
                    placeholder={(
                        <Button asChild>
                            <Link href={"/dashboard"}>
                                Tableau de bord
                            </Link>
                        </Button>
                    )}
                />
            </nav>
        </header>
    )
}
